"use strict";

var r,
  e = (r = require("axios")) && "object" == typeof r && "default" in r ? r.default : r,
  t = require("unist-util-select");
function n() {
  return (n = Object.assign || function (r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }).apply(this, arguments);
}
"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));
var o = function o(r, n) {
    try {
      return Promise.resolve(function () {
        try {
          return Promise.resolve(e.get("https://oembed.com/providers.json")).then(function (r) {
            return r.data;
          });
        } catch (r) {
          return Promise.reject(r);
        }
      }()).then(function (e) {
        var n = function (r, e) {
          void 0 === e && (e = !1);
          var n = [];
          return !0 === e ? t.selectAll(r, "inlineCode").forEach(function (r) {
            if (r.value.startsWith("oembed:")) {
              var e = r;
              e.url = e.value.substring(7).trim(), n.push(e);
            }
          }) : n = t.selectAll("paragraph link:only-child", r), n || [];
        }(r, !1);
        return Promise.resolve(Promise.all(n.map(function (r) {
          return a(r, e);
        }))).then(function () {
          return r;
        });
      });
    } catch (r) {
      return Promise.reject(r);
    }
  },
  a = function a(r, t) {
    void 0 === t && (t = []);
    try {
      var o = r,
        a = function (a, i) {
          try {
            var l = function () {
              var a = function (r, e) {
                  var t = {
                      url: null,
                      params: null
                    },
                    o = e || [],
                    a = Array.isArray(o),
                    i = 0;
                  for (o = a ? o : o[Symbol.iterator]();;) {
                    var l;
                    if (a) {
                      if (i >= o.length) break;
                      l = o[i++];
                    } else {
                      if ((i = o.next()).done) break;
                      l = i.value;
                    }
                    var u = l,
                      s = u.endpoints || [],
                      c = Array.isArray(s),
                      f = 0;
                    for (s = c ? s : s[Symbol.iterator]();;) {
                      var h;
                      if (c) {
                        if (f >= s.length) break;
                        h = s[f++];
                      } else {
                        if ((f = s.next()).done) break;
                        h = f.value;
                      }
                      var m = h,
                        y = m.schemes || [],
                        v = Array.isArray(y),
                        d = 0;
                      for (y = v ? y : y[Symbol.iterator]();;) {
                        var p;
                        if (v) {
                          if (d >= y.length) break;
                          p = y[d++];
                        } else {
                          if ((d = y.next()).done) break;
                          p = d.value;
                        }
                        var b = p;
                        b = b.replace("*", ".*"), new RegExp(b).test(r) && (t.url = m.url, t.params = n({
                          url: r
                        }, u.params));
                      }
                    }
                  }
                  return t;
                }(r.url, t),
                i = function () {
                  if (a.url) return Promise.resolve(function (r) {
                    try {
                      return Promise.resolve(e.get(r.url, {
                        params: n({
                          format: "json"
                        }, r.params)
                      })).then(function (r) {
                        return r.data;
                      });
                    } catch (r) {
                      return Promise.reject(r);
                    }
                  }(a)).then(function (e) {
                    o = function (r, e) {
                      return e.html ? (r.type = "html", r.value = e.html, delete r.children) : "photo" === e.type && (r.type = "html", r.value = '\n      <img src="' + e.url + '"\n        class="gatsby-remark-oembed-photo"\n        width="' + e.width + '"\n        height="' + e.width + '"\n        title="' + e.title + '"/>\n    ', delete r.children), r;
                    }(r, e);
                  });
                }();
              if (i && i.then) return i.then(function () {});
            }();
          } catch (r) {
            return i(r);
          }
          return l && l.then ? l.then(void 0, i) : l;
        }(0, function (e) {
          throw e.url = r.url, e;
        });
      return Promise.resolve(a && a.then ? a.then(function (r) {
        return o;
      }) : o);
    } catch (r) {
      return Promise.reject(r);
    }
  };
exports.default = function () {
  return o;
};